import React, { useCallback, useEffect } from "react";
import {
  GridLayout,
  GridLayoutItem,
  Stepper,
  StepperChangeEvent,
} from "@progress/kendo-react-layout";
import QuotationInformation from "./quotationforms/QuotationInformation";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { clearActiveStep, setActiveStep } from "./quotationSlice";
import { useLocation } from "react-router-dom";
import TourItinerary from "./quotationforms/TourItinerary";
import { getAllCities } from "../city/services/city.services";

type ActiveStepProps = {
  step: number;
};

const steps = [
  { label: "Quotation Information", isValid: undefined },
  { label: "Tour Itinerary", isValid: undefined },
];

const CreateQuotation: React.FC = () => {
  const dispatch = useAppDispatch();
  const location = useLocation();
  const ActiveStep = useAppSelector((state) => state.quotation.ActiveStep);

  useEffect(() => {
    dispatch(getAllCities());
    return () => {
      dispatch(clearActiveStep());
    };
  }, []);

  const renderActiveStep = useCallback(
    ({ step }: ActiveStepProps): React.ReactNode => {
      switch (step) {
        case 0:
          return <QuotationInformation />;
        case 1:
          return <TourItinerary />;
        default:
          return <QuotationInformation />;
      }
    },
    [ActiveStep]
  );

  const handleChange = (e: StepperChangeEvent) => {
    if (location.pathname !== "/quotation/package/create" || e?.value === 0) {
      dispatch(setActiveStep(e.value));
    }
  };

  return (
    <GridLayout cols={[{ width: "100%" }]}>
      <GridLayoutItem
        style={{
          padding: "15px 0",
        }}
      >
        <Stepper value={ActiveStep} onChange={handleChange} items={steps} />
      </GridLayoutItem>
      <GridLayoutItem>{renderActiveStep({ step: ActiveStep })}</GridLayoutItem>
    </GridLayout>
  );
};

export default CreateQuotation;
